// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb":"Breadcrumbs_breadcrumb__2tfKK","separator":"Breadcrumbs_separator__aOHaf"};